
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SAUModalService } from '@some-angular-utils/modal';
import { CompanyFormComponent } from '@/pages/companies/company-form/company-form.component';
import { IbanFormComponent } from './iban-form/iban-form.component';
import { Urls } from '@/apiConnection/urls';
import { ApiService } from '@/apiConnection/ApiService';
import { CompanyInterface } from '@/pages/companies/interfaces/CompanyInterface';
import { DatePipe } from '@angular/common';

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    DatePipe,
  ],
  templateUrl: './company.page.html',
  styleUrl: './company.page.scss',
})
export class CompanyPage {

  public company: CompanyInterface | undefined

  private sauModalService = inject(SAUModalService);

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getCompany()
  }

  getCompany() {
    const url = Urls.urls.company;

    this.apiService.getPetition(url).subscribe({
      next: (result: any) => {
        this.company = { ...result.list[0] };
        this.cdr.detectChanges()
      },
      error: () => {

      }
    })
  }

  openEditForm() {
    const modalRef = this.sauModalService.open(CompanyFormComponent, {});
    modalRef.componentInstance.id = this.company?.id || 0;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.getCompany();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openIbanForm() {
    const modalRef = this.sauModalService.open(IbanFormComponent, {});
    modalRef.componentInstance.currentIbans = this.company?.iban ?? [];

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.getCompany();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
